import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from '../../../ui/src/component/icon';
import './headerIcon.css';

const HeaderIcon = props => {
  return (
    <div className="header-icon clearfix">
      {props.icon && (
        <Icon name={props.icon} size="xl" className={'fill-bg-alt-dark'} />
      )}
      {props.customIcon}
      <div className={cx('h3', props.subtitle ? null : 'top-margin')}>
        {props.title}
      </div>
      {props.subtitle ? <div className="subtitle">{props.subtitle}</div> : null}
    </div>
  );
};

HeaderIcon.propTypes = {
  icon: PropTypes.string,
  customIcon: PropTypes.node,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default HeaderIcon;



// WEBPACK FOOTER //
// ./src/app/component/headerIcon/headerIcon.js